import { RowSelectionState } from '@tanstack/react-table';
import { devlog, immer } from 'zstore';
import create from 'zustand';

type PeopleState = {
  pageNumber: number;
  setPageNumber: (pageNumber: number) => void;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
  name: string;
  setName: (name: string) => void;
  sortColumn: string;
  setSortColumn: (sortColumn: string) => void;
  sortDirection: 'asc' | 'desc';
  setSortDirection: (sortDirection: 'asc' | 'desc') => void;
  rowSelection: RowSelectionState;
  setRowSelection: (updaterOrValue: RowSelectionState | ((old: RowSelectionState) => RowSelectionState)) => void;
};

const makePeopleStore = () => {
  return create<PeopleState>(
    devlog(
      immer((set: any) => ({
        pageNumber: 1,
        setPageNumber: (pageNumber: number) => set(() => ({ pageNumber })),
        pageSize: 10,
        setPageSize: (pageSize: number) => set(() => ({ pageSize })),
        name: '',
        setName: (name: string) => set(() => ({ name })),
        sortColumn: 'name',
        setSortColumn: (sortColumn: string) => set(() => ({ sortColumn })),
        sortDirection: 'asc',
        setSortDirection: (sortDirection: 'asc' | 'desc') => set(() => ({ sortDirection })),
        rowSelection: {},
        setRowSelection: (updaterOrValue) =>
          set((state) => ({
            rowSelection: typeof updaterOrValue === 'function' ? updaterOrValue(state.rowSelection) : updaterOrValue,
          })),
      }))
    )
  );
};

export const usePeopleStore = makePeopleStore();
